import dayjs from 'dayjs'
import { combineEpics, Epic, ofType } from 'redux-observable'
import { of } from 'rxjs'
import {
  catchError,
  filter,
  map,
  mergeMap,
  switchMap,
  withLatestFrom
} from 'rxjs/operators'
import { getHub } from '../../helpers/hub'
import { addToast } from '../toasts/actions'
import { getCookieConsentDate } from '../userPreferences/selectors'
import { logError } from '../ws/actions'
import { fetchUserPermissionsSuccess, setWebSettings } from './actions'
import CookieCloseButton from './helpers'
import { getIsOpenFin } from './selectors'
import { UserPermissions } from './types'

const getWebSettingsEpic: Epic = (action$) =>
  action$.pipe(
    ofType('settings.handleWindowSettings'),
    switchMap(() => {
      return getHub().invoke('GetWebSettings').pipe(map(setWebSettings))
    })
  )

const fetchUserPermissionsEpic: Epic = (action$) =>
  action$.pipe(
    ofType('webSettings.fetchUserPermissions'),
    mergeMap(() => {
      return getHub()
        .invoke<UserPermissions>('GetUserPermissions')
        .pipe(
          map((userPermissions: UserPermissions) =>
            fetchUserPermissionsSuccess(userPermissions)
          ),
          catchError((err) => of(logError(err)))
        )
    })
  )

const cookieConsentEpic: Epic = (action$, state$) =>
  action$.pipe(
    ofType('webSettings.setWebSettings'),
    withLatestFrom(state$),
    filter(() => {
      const isOpenFin = getIsOpenFin(state$.value)
      const browserCookie = document.cookie.includes('accepted-cookies')

      // Also check stored date in case user switches browsers
      const userPrefsCookieDate = dayjs(getCookieConsentDate(state$.value))
      const expirationDate = userPrefsCookieDate.add(1, 'year')
      const isValid =
        userPrefsCookieDate.isValid() &&
        userPrefsCookieDate.isBefore(expirationDate)

      return !browserCookie && !isValid && (!isOpenFin || fin.me.isView)
    }),
    map(() => {
      return addToast({
        message: 'By using our website you agree to the use of cookies',
        options: {
          position: 'bottom-center',
          toastId: 'cookie-notice',
          type: 'info',
          closeButton: CookieCloseButton,
          autoClose: false
        }
      })
    })
  )

export default combineEpics(
  getWebSettingsEpic,
  fetchUserPermissionsEpic,
  cookieConsentEpic
)
